<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="400px"
    @close="onCancel"
    :innerScroll="false"
    :loading="loadingBtn"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <div class="unable-listing-container">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="80px" size="mini" label-position="left">
        <el-form-item label="达播名称" prop="authorName">
          <el-input v-model="form.authorName" :disabled="!!rowData"></el-input>
        </el-form-item>
        <el-form-item label="控价周期" prop="pricePeriod" class="inputNum">
          <el-input-number v-model="form.pricePeriod" :controls="false" :min="1" :precision="0"></el-input-number> 
          <span>天</span>
        </el-form-item>
      </el-form>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'UnableListing',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return !!this.rowData ? '编辑' : '新增';
    },
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      form: {
        id: '',
        authorName: '',
        pricePeriod: undefined,
        seq: ''
      },
      rules: {
        authorName: [{ required: true, message: '请输入达播名称', trigger: 'blur' }],
        pricePeriod: [{ required: true, message: '请输入控价周期', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    if (!!this.rowData) {
      Object.assign(this.form, this.rowData);
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return;
        this.loadingBtn = true;
        let params = {
          ...this.form,
        };
        delete params.updatedBy;
        delete params.updatedDate;
        this.$q.configurationCenter
          .authorPeriodSave({ data: params })
          .then(res => {
            if (res.success) {
              this.$message.success(`${this.title}成功`);
              this.$emit('success');
              this.onCancel();
            }
          })
          .finally(() => {
            this.loadingBtn = false;
          });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.unable-listing-container {
  padding: 20px;
}

>>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input, >>> .el-input-number {
  width: 100% !important;
}

.inputNum >>> .el-input-number {
  width: 92% !important;
}

>>> .el-form-item {
  margin-bottom: 18px !important;
}
</style>
